import { useWalletClient } from "wagmi";

/**
 * Signer helper for modal step functions
 */
export const useWalletClientIsReady = () => {
  const signerQuery = useWalletClient();
  return { signerQuery, isSignerReady: signerQuery.isSuccess && !!signerQuery.data };
};
